$(document).ready(function () {

  /* ==========================================================================
     Two changes to the original.

     1. The 400ms hover delay the client asked for. The menu opens on :hover,
        which has no timing of its own, so the delay has to come from here —
        which is why the panel now opens on a class and the stylesheet turns
        the :hover rule off for the top row.

     2. A fix to how the panes were picked. The original did:

            $('.submenu-content').removeClass('active')
              .eq($(this).index('.submenu')).addClass('active');

        Both selectors are page-wide. $(this).index('.submenu') counts across
        every dropdown on the page rather than within the one being hovered,
        so as soon as two dropdowns use the same design the second one's
        indexes run past the end of its own panes and the wrong pane — or
        none — is shown. Everything below is scoped with
        .closest('.dropdown-content').
     ========================================================================== */

  /* 400ms on the top row is what stops the menu flying open when the pointer
     only crosses the bar on its way somewhere else. The rail gets 150ms: you
     are already inside the menu and reading the list, so the same wait there
     reads as lag. */
   /* ---- Hover timing --------------------------------------------------------
     Top row uses "hover intent": a menu opens as soon as the pointer slows
     down on it (moved less than INTENT_PX in one INTENT_MS check), or after
     INTENT_MAX_MS at the latest. A fast pass across the bar — on the way to
     the search box or the page — opens nothing. While a menu is open, moving
     to another top item switches straight away (SWITCH_MS).
     The rail keeps 150ms, enough to survive a diagonal; closing waits 250ms. */
  var INTENT_PX = 7;
  var INTENT_MS = 40;
  var INTENT_MAX_MS = 200;
  var SWITCH_MS = 0;
  var RAIL_MS = 150;
  var CLOSE_MS = 250;

  /* ---- Top level ---------------------------------------------------------
     The rhx-open class replaces the CSS :hover that used to open the panel,
     which is what makes room for the delay. The stylesheet switches the old
     :hover rule off. */
  var $menus = $('.rhinox-menu .dropdown').filter(function () {
    return $(this).find('.dropdown-content').length > 0;
  });

  $menus.each(function () {
    var $d = $(this);
    var poll = null, maxT = null, closeT = null;
    var x = 0, y = 0, px = 0, py = 0;

    function stopWatching() {
      clearInterval(poll);
      clearTimeout(maxT);
      poll = maxT = null;
      $d.off('mousemove.rhxIntent');
    }
    function openMenu() {
      stopWatching();
      $menus.not($d).removeClass('rhx-open');
      $d.addClass('rhx-open');
    }

    $d.on('mouseenter', function (e) {
      clearTimeout(closeT);

      /* Already browsing the menus: switch without waiting. */
      if ($menus.not($d).filter('.rhx-open').length) {
        if (SWITCH_MS > 0) maxT = setTimeout(openMenu, SWITCH_MS);
        else openMenu();
        return;
      }

      x = px = e.pageX;
      y = py = e.pageY;
      $d.on('mousemove.rhxIntent', function (ev) { x = ev.pageX; y = ev.pageY; });
      poll = setInterval(function () {
        if (Math.abs(x - px) + Math.abs(y - py) < INTENT_PX) openMenu();
        px = x;
        py = y;
      }, INTENT_MS);
      maxT = setTimeout(openMenu, INTENT_MAX_MS);
    });

    $d.on('mouseleave', function () {
      stopWatching();
      /* The close delay is the half that fixes the diagonal. Moving from
         Bobcat down and to the right towards its models crosses Case on the
         way; without a delay Case takes over before the pointer arrives. */
      closeT = setTimeout(function () {
        $d.removeClass('rhx-open');
      }, CLOSE_MS);
    });

    /* Keyboard does not wait — tabbing to a menu is already unambiguous. */
    $d.on('focusin', function () {
      clearTimeout(closeT);
      stopWatching();
      $d.addClass('rhx-open');
    });
    $d.on('focusout', function (e) {
      if (!$.contains($d[0], e.relatedTarget)) $d.removeClass('rhx-open');
    });
  });

  /* ---- Rail: design_1 -------------------------------------------------- */
  $('.submenu').each(function () {
    var $li = $(this);
    var $panel = $li.closest('.dropdown-content');
    var t = null;

    $li.on('mouseenter', function () {
      t = setTimeout(function () {
        var i = $panel.find('.submenu').index($li);
        $panel.find('.submenu').removeClass('is-current').eq(i).addClass('is-current');
        $panel.find('.submenu-content').removeClass('active').eq(i).addClass('active');
      }, RAIL_MS);
    });
    $li.on('mouseleave', function () { clearTimeout(t); });
  });

  /* ---- Rail: design_2 -------------------------------------------------- */
  $('.submenu-qh').each(function () {
    var $li = $(this);
    var $panel = $li.closest('.dropdown-content');
    var t = null;

    $li.on('mouseenter', function () {
      t = setTimeout(function () {
        var i = $panel.find('.submenu-qh').index($li);
        $panel.find('.submenu-qh').removeClass('is-current').eq(i).addClass('is-current');
        $panel.find('.submenu-content-qh').removeClass('active').eq(i).addClass('active');
      }, RAIL_MS);
    });
    $li.on('mouseleave', function () { clearTimeout(t); });
  });

  /* ---- design_3 groups -------------------------------------------------
     The open one is scrolled into view as well. The last row in the list
     expands below the bottom of a panel that is already full, so from the
     outside it looked like hovering it did nothing at all. */
  $('.terms').each(function () {
    var $li = $(this);
    var $panel = $li.closest('.dropdown-content');
    var $scroller = $li.closest('.machines-display');
    var t = null;

    $li.on('mouseenter', function () {
      t = setTimeout(function () {
        var i = $panel.find('.terms').index($li);
        $panel.find('.terms_more').removeClass('active');
        var $body = $panel.find('.terms_more').eq(i).addClass('active');

        if (!$scroller.length || !$body.length) return;
        requestAnimationFrame(function () {
          var over = $body[0].getBoundingClientRect().bottom -
                     $scroller[0].getBoundingClientRect().bottom;
          if (over > 0) $scroller[0].scrollTop += over + 10;
        });
      }, RAIL_MS);
    });
    $li.on('mouseleave', function () { clearTimeout(t); });
  });

  /* ---- Carried over from the original ---------------------------------- */
  $('.machine-sel').on('mouseenter', function () { $('.submenu-one').addClass('active'); });
  $('.sel-qh').on('mouseenter', function () { $('.submenu-one-qh').addClass('active'); });

  $('.bucket-attach').on('mouseover', function () {
    var $panel = $(this).closest('.dropdown-content');
    var i = $panel.find('.bucket-attach').index(this);
    $panel.find('.bucket-content').removeClass('active').eq(i).addClass('active');
  });

  /* Highlight NEW wherever it appears in a rail label. */
  $('.make_name').each(function () {
    var txt = $(this).text();
    if (/\bNEW\b/.test(txt)) {
      /* The separator goes into the chip with it — a chip does not need a
         dash after it. */
      $(this).html(
        txt.replace(/\bNEW\b\s*[-\u2013\u2014]?\s*/, '<span class="highlight-new">NEW</span> ')
      );
    }
  });
});


(function () {
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Settings printed by sections/new-header.liquid */
  var norm = function (s) {
    return String(s || '').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim().toLowerCase();
  };
  var cfg = { cardLinks: {}, hover: {}, hoverUrls: [] };
  (function readConfig() {
    var el = document.getElementById('rhx-menu-tiles');
    if (!el) return;
    try {
      var d = JSON.parse(el.textContent);
      cfg.hintText = d.hintText || '';
      cfg.hintLinkLabel = d.hintLinkLabel || '';
      cfg.hintLinkUrl = d.hintLinkUrl || '/pages/machine-selection';
      (d.cardLinks || []).forEach(function (c) { if (c.url) cfg.cardLinks[norm(c.item)] = c.url; });
      /* Key: "tonnage | type" for one tonnage, "type" for all tonnages. */
      (d.hoverImages || []).forEach(function (h) {
        if (!h.type || !h.src) return;
        var key = h.size ? norm(h.size) + ' | ' + norm(h.type) : norm(h.type);
        cfg.hover[key] = h;
        cfg.hoverUrls.push(h.src);
      });
    } catch (e) { /* bad JSON: menu still works, just without the extras */ }
  })();

  function makeTile(label, url, extraClass) {
    var a = document.createElement('a');
    a.className = 'rhxt-tile' + (extraClass ? ' ' + extraClass : '');
    a.href = url || '#';
    var span = document.createElement('span');
    span.textContent = label;
    a.appendChild(span);
    return a;
  }

  var hoverState = new Map(); // pane → { card, def, size }

  function makeCard(img, cap, url) {
    var card = document.createElement('a');
    card.className = 'rhxt-card';
    card.href = url || '#';
    var imgBox = document.createElement('span');
    imgBox.className = 'rhxt-card-img';
    if (!img) { img = document.createElement('img'); img.alt = ''; }
    imgBox.appendChild(img);
    card.appendChild(imgBox);

    var label = document.createElement('span');
    label.className = 'rhxt-card-label';
    if (!cap) label.classList.add('is-empty');
    var text = document.createElement('span');
    text.textContent = cap || '';
    var chev = document.createElement('span');
    chev.className = 'rhxt-card-chev';
    chev.innerHTML = CHEV;
    label.appendChild(text);
    label.appendChild(chev);
    card.appendChild(label);
    return card;
  }

  /* Put data { src, label, url, alt } into a pane's card; null = tonnage default. */
  function showCard(pane, data) {
    var st = hoverState.get(pane);
    if (!st) return;
    data = data || st.def;
    if (!data) { st.card.classList.add('is-hidden'); return; }
    var img = st.card.querySelector('img');
    if (img.getAttribute('src') !== data.src) {
      img.removeAttribute('srcset');
      img.setAttribute('src', data.src);
    }
    img.alt = data.alt || data.label || '';
    var label = st.card.querySelector('.rhxt-card-label');
    label.querySelector('span').textContent = data.label || '';
    label.classList.toggle('is-empty', !data.label);
    st.card.href = data.url || '#';
    st.card.classList.remove('is-hidden');
  }

  function resetCards() {
    hoverState.forEach(function (st, pane) { showCard(pane, null); });
  }

  function hoverImageFor(size, type) {
    return cfg.hover[norm(size) + ' | ' + norm(type)] || cfg.hover[norm(type)] || null;
  }

  /* Each tonnage's default = the first bucket type in its list with an image. */
  function applyFirstDefaults() {
    hoverState.forEach(function (st, pane) {
      var links = pane.querySelectorAll('.rhx-col li a');
      for (var j = 0; j < links.length; j++) {
        var type = links[j].textContent.trim();
        var h = hoverImageFor(st.size, type);
        if (h) {
          st.def = {
            src: h.src,
            label: h.label || type,
            url: h.url || links[j].getAttribute('href'),
            alt: h.alt || h.label || type
          };
          break;
        }
      }
    });
    resetCards();
  }

  function bindHover(panel) {
    panel.addEventListener('mouseover', function (e) {
      var link = e.target.closest('.rhx-col li a');
      if (!link) {
        if (e.target.closest('.leftdiv')) resetCards(); // another tonnage
        return;
      }
      var pane = link.closest('.submenu-content');
      var st = hoverState.get(pane);
      if (!st) return;
      var type = link.textContent.trim();
      var h = hoverImageFor(st.size, type);
      if (!h) { showCard(pane, null); return; }
      showCard(pane, {
        src: h.src,
        label: h.label || type,
        url: h.url || link.getAttribute('href'),
        alt: h.alt || h.label || type
      });
    });

    var dd = panel.closest('.dropdown');
    if (!dd) return;
    dd.addEventListener('mouseleave', resetCards);

    /* Preload the hover images the first time the menu opens. */
    var preloaded = false;
    new MutationObserver(function () {
      if (preloaded || !dd.classList.contains('rhx-open')) return;
      preloaded = true;
      cfg.hoverUrls.forEach(function (u) { var i = new Image(); i.src = u; });
    }).observe(dd, { attributes: true, attributeFilter: ['class'] });
  }

  function build() {
    var panels = document.querySelectorAll('.rhinox-menu .dropdown-content.row-full');
    Array.prototype.forEach.call(panels, function (panel) {
      if (!panel.querySelector('.rhx-aside')) return;
      var rail = panel.querySelectorAll('.leftdiv li.submenu');
      var panes = Array.prototype.filter.call(panel.children, function (el) {
        return el.classList.contains('submenu-content');
      });

      panes.forEach(function (pane, i) {
        Array.prototype.forEach.call(pane.querySelectorAll('.rhx-aside'), function (aside) {
          if (aside.classList.contains('rhxt-built')) return;

          var img = aside.querySelector('img');
          var link = rail[i] ? rail[i].querySelector('a') : null;
          var href = link ? link.getAttribute('href') : '#';
          var railTitle = link ? link.textContent.trim() : '';
          var capEl = aside.querySelector('.sidecontent');
          var cap = capEl ? capEl.textContent.trim() : '';

          /* Take the image away from the lazy-loader (lazysizes). This script
             sets the card's src itself; left alone, lazysizes swaps the
             tonnage's original image back in (from data-src) the first time
             the tonnage is shown. The original is only downloaded if the card
             actually uses it (a tonnage with no bucket type images). */
          var ownSrc = '';
          if (img) {
            ownSrc = img.getAttribute('data-src') || img.getAttribute('src') || '';
            img.classList.remove('lazyload', 'lazyloading', 'lazyloaded');
            ['data-src', 'data-srcset', 'data-sizes'].forEach(function (a) { img.removeAttribute(a); });
          }
          if (img && !img.getAttribute('alt')) img.setAttribute('alt', cap || railTitle);

          var tile = makeTile('Shop all ' + railTitle, href);

          /* No image for this size: the no-image layout. */
          if (!img) {
            tile.classList.add('rhxt-tile--solo');
            aside.appendChild(tile);

            if (cfg.hintText || cfg.hintLinkLabel) {
              var hint = document.createElement('p');
              hint.className = 'rhxt-hint';
              if (cfg.hintText) hint.appendChild(document.createTextNode(cfg.hintText));
              if (cfg.hintText && cfg.hintLinkLabel) hint.appendChild(document.createElement('br'));
              if (cfg.hintLinkLabel) {
                var link = document.createElement('a');
                link.href = cfg.hintLinkUrl;
                link.textContent = cfg.hintLinkLabel;
                hint.appendChild(link);
              }
              aside.appendChild(hint);
            }

            /* Hidden card, shown only while a bucket type with an image is hovered. */
            var hoverCard = makeCard(null, '', href);
            hoverCard.classList.add('is-hidden');
            aside.insertBefore(hoverCard, aside.firstChild);
            hoverState.set(pane, { card: hoverCard, def: null, size: railTitle });

            aside.classList.add('rhxt-solo', 'rhxt-built');
            return;
          }

          /* Image link: the slot's "Collection link" setting, else the rail item's own link. */
          var cardHref = cfg.cardLinks[norm(railTitle)] || href;
          var card = makeCard(img, cap, cardHref);
          hoverState.set(pane, {
            card: card,
            def: { src: ownSrc, label: cap, url: cardHref, alt: img.getAttribute('alt') || cap },
            size: railTitle
          });

          aside.appendChild(card);
          aside.appendChild(tile);
          aside.classList.add('rhxt-built');
        });
      });
    });
  }

  /* ---------- 2. Responsive size + position ---------- */
  var GAP = 16;                      // kept from the right edge of the window
  var SMALL = 1100, LARGE = 1600;    // window widths for the sizes below
  var BUCKETS = { small: 1.1,  large: 16 / 12 };
  var OTHERS  = { small: 0.85, large: 1 };
  var MIN_ZOOM = 0.75;

  function fit(dd) {
    var panel = null;
    for (var i = 0; i < dd.children.length; i++) {
      if (dd.children[i].classList.contains('dropdown-content')) { panel = dd.children[i]; break; }
    }
    if (!panel) return;
    if (panel.classList.contains('rhx-mega')) return;   // the large menu sizes itself
    if (!dd.classList.contains('rhx-open')) {
      panel.style.setProperty('--rhx-shift', '0px');
      return;
    }

    var nav = document.querySelector('.rhinox-menu-links') || document.querySelector('.rhinox-menu');
    var vw = document.documentElement.clientWidth;
    var minLeft = Math.max(GAP, nav ? Math.round(nav.getBoundingClientRect().left) : GAP);
    var maxRight = vw - GAP;
    var isBuckets = panel.classList.contains('row-full') && !!panel.querySelector('.rhx-aside');
    var range = isBuckets ? BUCKETS : OTHERS;

    var t = Math.min(1, Math.max(0, (vw - SMALL) / (LARGE - SMALL)));
    var want = range.small + (range.large - range.small) * t;

    /* Natural size first, then cap by the space available. */
    panel.style.setProperty('--rhx-shift', '0px');
    panel.style.setProperty('--rhx-zoom', '1');
    var r0 = panel.getBoundingClientRect();
    if (!r0.width || !r0.height) return;
    var byWidth = (maxRight - minLeft) / r0.width;
    var byHeight = (window.innerHeight - r0.top - GAP) / r0.height;
    var zoom = Math.round(Math.max(MIN_ZOOM, Math.min(want, byWidth, byHeight)) * 100) / 100;
    panel.style.setProperty('--rhx-zoom', String(zoom));

    var r = panel.getBoundingClientRect();
    var shift = 0;
    if (r.right > maxRight) shift = -Math.min(r.right - maxRight, Math.max(0, r.left - minLeft));
    else if (r.left < minLeft) shift = Math.min(minLeft - r.left, Math.max(0, maxRight - r.right));
    /* A translate inside a zoomed element is multiplied by the zoom. */
    panel.style.setProperty('--rhx-shift', Math.round(shift / zoom) + 'px');
  }

  function watch() {
    var dds = Array.prototype.filter.call(document.querySelectorAll('.rhinox-menu .dropdown'), function (d) {
      return d.querySelector('.dropdown-content');
    });
    if (!dds.length || !window.MutationObserver) return;

    /* Refit when a menu opens (the menu script toggles .rhx-open). */
    var openMO = new MutationObserver(function (list) {
      list.forEach(function (m) { fit(m.target); });
    });

    /* Refit when the menu script changes a panel's width (Hitches 20vw/39vw),
       ignoring the style changes this script makes itself. */
    var lastW = new WeakMap();
    var widthMO = new MutationObserver(function (list) {
      list.forEach(function (m) {
        var p = m.target, w = p.style.width;
        if (lastW.get(p) === w) return;
        lastW.set(p, w);
        fit(p.parentElement);
      });
    });

    dds.forEach(function (dd) {
      openMO.observe(dd, { attributes: true, attributeFilter: ['class'] });
      var p = dd.querySelector('.dropdown-content');
      lastW.set(p, p.style.width);
      widthMO.observe(p, { attributes: true, attributeFilter: ['style'] });
      fit(dd);
    });

    var raf = null;
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { dds.forEach(fit); });
    });
  }


  /* ==========================================================================
     3. Large desktop menu ("mega menu")

     Replaces the five desktop dropdowns with one large three-column panel
     each (left rows | middle list | right column), built from the links
     already rendered by snippets/menu-top-bar-desktop.liquid, so the
     navigation menus in Shopify stay the source of truth.

       Shop by Machine        makes | models | Dedicated Hanger Ranges tiles
       Buckets & Attachments  tonnages | groups | hover image card + Shop all
       Hitches/Couplers       Hydraulic / Manual (one link per brand) /
                              Quick Hitch Spares | brands | content blocks
       Wear Parts             one column (sub-lists flattened) | – | content
       About Us               rows (groups open in the middle) | list | content

     Images, labels and links for the tiles and content blocks come from the
     header section settings ("Desktop menu: …"), passed in the
     #rhx-menu-tiles data block as "mega". Anything left empty falls back
     to the values in MEGA_DEFAULTS below. Turning off "Use the large
     desktop menu" in the header settings brings back the previous menu.
     Styling: section 10 of the menu CSS.
     ========================================================================== */
  var MEGA_DEFAULTS = {
    aimMs: 120,                 // left column: wait this long only while the pointer heads right
    hangerHeading: 'Dedicated Hanger Ranges',
    hangers: [
      { label: 'Tilt Rotators',  rail: 'tilt rotator buckets & attachments', img: 'S45' },
      { label: 'Martin Hitch',   rail: 'martin hitch system',                img: 'MM03' },
      { label: 'Safelock Hitch', rail: 'safelock buckets',                   img: 'SL10' }
    ],
    manualLabel: 'Manual Quick Hitches',
    manualUrl: '/collections/rhinox-manual-quick-hitch',
    sparesLabel: 'Quick Hitch Spares',
    sparesUrl: '/collections/quick-hitch-spares-rebuild-kit',
    aboutHeadings: { 'for business': 'Business Type', 'corporate responsibility': 'Policies' },
    content: {
      hitches: { card: { img: 'Manual Quick Hitches', label: 'Manual Quick Hitches', url: '' },
                 tile: { label: 'Shop by Machine', sub: 'Find the right fit by make & model', url: '' } },
      wear:    { card: { img: 'Ripper Teeth', label: 'Ripper Teeth', url: '' },
                 tile: { label: 'Shop by Machine', sub: 'Find the right fit by make & model', url: '' } },
      about:   { card: { img: 'Land Clearance Rakes', label: 'Blog, Guides & News', url: '/blogs/news' },
                 tile: { label: 'Request a Brochure', sub: '', url: '/pages/brochure-request-form' } }
    }
  };

  function buildMega() {
    var data = {};
    try { data = JSON.parse((document.getElementById('rhx-menu-tiles') || {}).textContent || '{}') || {}; } catch (e) { data = {}; }
    var S = data.mega || {};
    if (S.enabled === false) return false;
    var menu = document.querySelector('.rhinox-menu');
    if (!menu) return false;
    var D = MEGA_DEFAULTS;
    var pick = function (v, d) { return v != null && String(v).trim() !== '' ? v : d; };

    var txt = function (el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; };
    var el = function (tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var stripNew = function (s) { return s.replace(/\s*[-–—]?\s*\bNEW\b\s*[-–—]?\s*/, ' ').trim(); };
    var RCHEV = '<svg class="rhx-mm-chev" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var CTA_CHEV = '<svg class="rhx-mm-cta-chev" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 4h13v13" stroke="currentColor" stroke-width="3.4" stroke-linecap="square"/></svg>';
    var dds = Array.prototype.slice.call(menu.querySelectorAll('.dropdown'));
    var btnOf = function (dd) { return dd.querySelector('.dropbtn'); };
    var findDD = function (re) { return dds.filter(function (dd) { return re.test(txt(btnOf(dd))); })[0]; };
    var panelOf = function (dd) { return dd && Array.prototype.filter.call(dd.children, function (c) { return c.classList.contains('dropdown-content'); })[0]; };
    var topHref = function (dd) { var a = dd && dd.querySelector(':scope > a'); return a ? a.getAttribute('href') : null; };
    var kids = function (p, cls) { return Array.prototype.filter.call(p.children, function (c) { return c.classList.contains(cls); }); };
    var all = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var ddMachine = findDD(/machine selection|shop by machine/i);
    var ddBuckets = findDD(/buckets/i);
    var ddHitches = findDD(/hitch|coupler/i);
    var ddWear    = findDD(/wear parts/i);
    var ddAbout   = findDD(/about/i);
    if ([ddMachine, ddBuckets, ddHitches, ddWear, ddAbout].some(function (d) { return !d || !panelOf(d); })) return false;
    var MACHINE_URL = topHref(ddMachine) || '/pages/machine-selection';

    /* Bucket type images: per tonnage first, then for every tonnage */
    var IMG = {}, IMGS = {};
    (data.hoverImages || []).forEach(function (h) {
      if (!h.type || !h.src) return;
      if (h.size) IMGS[norm(h.size) + ' | ' + norm(h.type)] = h; else IMG[norm(h.type)] = h;
    });
    var imageFor = function (size, type) { return IMGS[norm(size) + ' | ' + norm(type)] || IMG[norm(type)] || null; };
    /* An image setting (URL) or a bucket type name to borrow its image from */
    var srcOf = function (v) { return !v ? '' : /^(https?:)?\/\/|^\/|\.(png|jpe?g|webp|gif)(\?|$)/i.test(v) ? v : ((IMG[norm(v)] || {}).src || ''); };

    /* ---------- Read the current menus ---------- */
    var linkObj = function (a) {
      return { name: stripNew(txt(a)), url: a.getAttribute('href'), isNew: /\bNEW\b/.test(txt(a)),
               label: a.getAttribute('href') === '#' || !!a.closest('.this-hash-menu') };
    };
    var colGroups = function (pane) {
      return all(pane, '.rhx-col').map(function (c) {
        return { title: txt(c.querySelector('.model-title')), links: all(c, 'li a').map(linkObj) };
      }).filter(function (g) { return g.links.length; });
    };
    var railOf = function (panel, sel) {
      return all(panel, '.leftdiv ' + sel).map(function (li) {
        var a = li.querySelector('a'), ne = li.querySelector('.make_name'), t = txt(ne) || txt(a);
        return { name: stripNew(t), url: a ? a.getAttribute('href') : null, isNew: /\bNEW\b/.test(t) };
      });
    };

    /* Shop by Machine */
    var mp = panelOf(ddMachine), mPanes = kids(mp, 'submenu-content');
    var makes = railOf(mp, 'li.submenu').map(function (m, i) {
      var g = mPanes[i] ? colGroups(mPanes[i]) : [];
      m.groups = g.length ? g.map(function (x) { return { title: x.title || 'Models', links: x.links }; }) : null;
      return m;
    });

    /* Buckets & Attachments: tonnages, groups, and the tonnage's own image (theme Collection Image) */
    var bp = panelOf(ddBuckets), bPanes = kids(bp, 'submenu-content');
    var tonnages = railOf(bp, 'li.submenu').map(function (t, i) {
      var pane = bPanes[i];
      t.groups = pane ? colGroups(pane) : [];
      var raw = pane && pane.querySelector('.rhx-aside img');
      var src = raw ? (raw.getAttribute('data-src') || raw.getAttribute('src') || '') : '';
      t.own = src && !/dummy\.png/.test(src) ? { src: src, label: txt(pane.querySelector('.rhx-aside .sidecontent')), url: t.url } : null;
      var own = (data.cardLinks || []).filter(function (c) { return norm(c.item) === norm(t.name); })[0];
      if (t.own && own && own.url) t.own.url = own.url;
      return t;
    });

    /* Hitches/Couplers: spares to the first level, one link per brand under Manual */
    var hp = panelOf(ddHitches), hPanes = kids(hp, 'submenu-content-qh');
    var hLinks = [], brands = [], spareUrls = [];
    railOf(hp, 'li.submenu-qh').forEach(function (r, i) {
      var k = hPanes[i] ? all(hPanes[i], 'li a').map(linkObj) : [];
      if (!k.length) { hLinks.push(r); return; }
      var main = k.filter(function (x) { return !/spare/i.test(x.name); })[0] || r;
      k.filter(function (x) { return /spare/i.test(x.name); }).forEach(function (x) { if (spareUrls.indexOf(x.url) < 0) spareUrls.push(x.url); });
      brands.push({ name: r.name.replace(/\s*(manual\s+)?quick\s+(hitch(es)?|couplers?)\s*$/i, '').trim() || r.name, url: main.url || r.url });
    });
    var hitchRows = hLinks.concat([
      { name: D.manualLabel, url: pick(S.manualUrl, D.manualUrl), groups: [{ title: 'Machine Make', links: brands }] },
      { name: D.sparesLabel, url: pick(S.sparesUrl, spareUrls.length === 1 ? spareUrls[0] : D.sparesUrl) }
    ]);

    /* Wear Parts / About Us lists: top-level rows; groups keep their links */
    var readList = function (dd) {
      var ul = panelOf(dd).querySelector('.machines-display ul.submenu-menu');
      var rows = [];
      Array.prototype.forEach.call(ul ? ul.children : [], function (li) {
        if (li.classList.contains('terms_more')) return;
        var a = li.querySelector(':scope > a') || li.querySelector('a');
        if (!a) return;
        var row = { name: stripNew(txt(a)), url: a.getAttribute('href'), isNew: /\bNEW\b/.test(txt(a)) };
        if (li.classList.contains('terms')) {
          var more = li.nextElementSibling && li.nextElementSibling.classList.contains('terms_more') ? li.nextElementSibling : null;
          row.groups = [{ title: '', links: more ? all(more, 'li a').map(linkObj) : [] }];
        }
        rows.push(row);
      });
      return rows;
    };
    /* Wear Parts: one column; sub-lists flattened; a heading repeated by its own link is dropped; each name once */
    var wearRows = [], seenW = {};
    readList(ddWear).forEach(function (r) {
      var k = r.groups ? r.groups[0].links : [];
      var list = !r.groups ? [r] : k.some(function (x) { return x.url === r.url || norm(x.name) === norm(r.name); }) ? k : [r].concat(k);
      list.forEach(function (x) { var key = norm(x.name); if (!seenW[key]) { seenW[key] = 1; wearRows.push({ name: x.name, url: x.url, isNew: x.isNew }); } });
    });
    var aboutRows = readList(ddAbout).map(function (r) {
      if (r.groups) r.groups = [{ title: D.aboutHeadings[norm(r.name)] || '', links: r.groups[0].links }];
      return r;
    });

    /* ---------- Settings → content ---------- */
    var content = function (key) {
      var d = D.content[key], s = (S.content || {})[key] || {}, sc = s.card || {}, st = s.tile || {};
      return {
        card: { img: pick(sc.img, d.card.img), label: pick(sc.label, d.card.label), url: pick(sc.url, d.card.url) },
        tile: { label: pick(st.label, d.tile.label), sub: st.sub != null ? st.sub : d.tile.sub, url: pick(st.url, d.tile.url) }
      };
    };
    var cHitches = content('hitches'), cWear = content('wear'), cAbout = content('about');
    if (!cHitches.card.url) cHitches.card.url = pick(S.manualUrl, D.manualUrl);
    if (!cWear.card.url) {
      var rt = [];
      tonnages.forEach(function (t) { t.groups.forEach(function (g) { g.links.forEach(function (l) { if (norm(l.name) === 'ripper teeth') rt.push(l); }); }); });
      cWear.card.url = rt[0] ? rt[0].url : topHref(ddWear);
    }
    var hangers = D.hangers.map(function (d, i) {
      var s = (S.hangers || [])[i] || {};
      var t = tonnages.filter(function (x) { return norm(x.name) === d.rail; })[0];
      /* Text cleared in the theme editor ("") hides the tile; not set uses the default */
      return { label: s.label === '' ? '' : pick(s.label, d.label), img: pick(s.img, d.img), url: pick(s.url, t ? t.url : '#') };
    }).filter(function (h) { return h.label; });

    /* ---------- Build ---------- */
    var newPanel = function (dd, extra) {
      var p = el('div', 'dropdown-content rhx-mega ' + extra);
      dd.replaceChild(p, panelOf(dd));
      return p;
    };
    /* Scrolling column: .rhx-mm-wrap > .rhx-mm-scroll + .rhx-mm-bar (grey line, yellow thumb) */
    var scrollCol = function (cls) {
      var wrap = el('div', 'rhx-mm-col rhx-mm-wrap ' + cls);
      var sc = el('div', 'rhx-mm-scroll');
      var bar = el('div', 'rhx-mm-bar', '<i class="rhx-mm-thumb"></i>');
      wrap.appendChild(sc); wrap.appendChild(bar);
      var thumb = bar.firstChild;
      sc.rhxUpdate = function () {
        var h = sc.clientHeight, H = sc.scrollHeight;
        if (!h) return;
        var ratio = Math.min(1, h / H);
        thumb.style.height = (ratio * 100) + '%';
        thumb.style.top = (H > h ? (sc.scrollTop / (H - h)) * (1 - ratio) * 100 : 0) + '%';
      };
      sc.addEventListener('scroll', sc.rhxUpdate, { passive: true });
      wrap.rhxScroll = sc;
      return wrap;
    };
    var railRow = function (label, url, chev, isNew) {
      var r = el(url ? 'a' : 'div', 'rhx-mm-row', '<span>' + esc(label) + (isNew ? '<span class="rhx-mm-new">NEW</span>' : '') + '</span>' + (chev ? RCHEV : ''));
      if (url) r.href = url; else { r.setAttribute('role', 'button'); r.tabIndex = 0; }
      return r;
    };
    /* Left column: instant when moving up/down; only while heading right towards
       the middle column does a row wait aimMs (cancelled if the pointer leaves). */
    var bindRail = function (rows, select, col) {
      var t = null, lx = null, ly = null, dx = 0, dy = 0;
      col.addEventListener('mousemove', function (e) {
        if (lx !== null) { dx = e.clientX - lx; dy = e.clientY - ly; }
        lx = e.clientX; ly = e.clientY;
      });
      col.addEventListener('mouseleave', function () { clearTimeout(t); lx = ly = null; dx = dy = 0; });
      rows.forEach(function (r, i) {
        r.addEventListener('mouseenter', function () {
          clearTimeout(t);
          if (dx > 0 && dx >= Math.abs(dy)) t = setTimeout(function () { select(i); }, D.aimMs);
          else select(i);
        });
        r.addEventListener('focus', function () { select(i); });
        if (r.tagName !== 'A') r.addEventListener('click', function () { select(i); });
      });
    };
    var linksHtml = function (links) {
      return '<ul class="rhx-mm-links">' + links.map(function (l) {
        return l.label ? '<li class="rhx-mm-label">' + esc(l.name) + '</li>'
          : '<li><a href="' + esc(l.url) + '">' + esc(l.name) + (l.isNew ? '<span class="rhx-mm-new">NEW</span>' : '') + '</a></li>';
      }).join('') + '</ul>';
    };
    var groupsHtml = function (groups) {
      return groups.map(function (g) {
        return '<div class="rhx-mm-group">' + (g.title ? '<div class="rhx-mm-h">' + esc(g.title) + '</div>' : '') + linksHtml(g.links) + '</div>';
      }).join('');
    };
    var ctaEl = function (t) {
      var a = el('a', 'rhx-mm-cta', CTA_CHEV + '<span class="rhx-mm-cta-text">' + esc(t.label) + (t.sub ? '<span class="rhx-mm-cta-sub">' + esc(t.sub) + '</span>' : '') + '</span>');
      a.href = t.url || MACHINE_URL;
      return a;
    };
    var cardEl = function (c) {
      var a = el('a', 'rhx-mm-card', '<img alt="" loading="lazy"><span></span>');
      if (c) {
        var s = srcOf(c.img);
        if (s) a.querySelector('img').src = s; else a.classList.add('is-hidden');
        a.querySelector('img').alt = c.label || '';
        a.querySelector('span').textContent = c.label || '';
        a.href = c.url || '#';
      }
      return a;
    };
    var contentAside = function (c) {
      var aside = el('div', 'rhx-mm-col rhx-mm-aside');
      aside.appendChild(cardEl(c.card));
      aside.appendChild(ctaEl(c.tile));
      return aside;
    };
    var buildMenu = function (dd, cls, rows, aside, opts) {
      opts = opts || {};
      var p = newPanel(dd, cls);
      var railW = scrollCol('rhx-mm-rail'), listW = scrollCol('rhx-mm-list');
      var rail = railW.rhxScroll, list = listW.rhxScroll;
      var els = rows.map(function (r) { return railRow(r.name, r.url, !!(r.groups && r.groups.length), r.isNew); });
      els.forEach(function (e) { rail.appendChild(e); });
      if (opts.noList) { listW.classList.add('rhx-mm-list--empty'); listW.querySelector('.rhx-mm-bar').style.display = 'none'; }
      p.appendChild(railW); p.appendChild(listW); p.appendChild(aside);
      var select = function (i) {
        if (opts.noList) return;
        els.forEach(function (e, j) { e.classList.toggle('is-current', j === i); });
        var r = rows[i];
        list.innerHTML = '<div class="rhx-mm-top"><div class="rhx-mm-title">' + esc(r.name) + '</div></div>' + (r.groups && r.groups.length
          ? groupsHtml(r.groups)
          : '<p class="rhx-mm-empty"><a href="' + esc(r.url || '#') + '">' + esc(opts.emptyText ? opts.emptyText(r) : 'Shop ' + r.name) + '</a></p>');
        list.scrollTop = 0;
        list.rhxUpdate();
        if (opts.onSelect) opts.onSelect(i, list);
      };
      bindRail(els, select, railW);
      var first = Math.max(0, rows.map(function (r) { return !!(r.groups && r.groups.length); }).indexOf(true));
      return { p: p, reset: function () { select(first); } };
    };

    /* Shop by Machine */
    var mAside = el('div', 'rhx-mm-col rhx-mm-aside', '<div class="rhx-mm-h">' + esc(pick(S.hangerHeading, D.hangerHeading)) + '</div>');
    var tiles = el('div', 'rhx-mm-tiles');
    hangers.forEach(function (h) {
      var s = srcOf(h.img);
      var a = el('a', 'rhx-mm-tile', (s ? '<img src="' + esc(s) + '" alt="' + esc(h.label) + '" loading="lazy">' : '') + '<span>' + esc(h.label) + '</span>');
      a.href = h.url || '#';
      tiles.appendChild(a);
    });
    mAside.appendChild(tiles);
    var M = buildMenu(ddMachine, 'rhx-mm--machine', makes, mAside, { emptyText: function (m) { return 'See every bucket and attachment for ' + m.name; } });

    /* Buckets & Attachments */
    var bAside = el('div', 'rhx-mm-col rhx-mm-aside');
    var card = cardEl(null), shopAll = ctaEl({ label: '', url: '#' });
    var hint = el('p', 'rhx-mm-hint');
    if (data.hintText || data.hintLinkLabel) {
      hint.innerHTML = esc(data.hintText || '') + (data.hintText && data.hintLinkLabel ? '<br>' : '') +
        (data.hintLinkLabel ? '<a href="' + esc(data.hintLinkUrl || MACHINE_URL) + '">' + esc(data.hintLinkLabel) + '</a>' : '');
    }
    bAside.appendChild(card); bAside.appendChild(shopAll); bAside.appendChild(hint);
    var cardImg = card.querySelector('img'), cardLabel = card.querySelector('span');
    var showCard = function (d) {
      card.classList.toggle('is-hidden', !d);
      hint.style.display = d ? 'none' : '';
      if (!d) return;
      if (cardImg.getAttribute('src') !== d.src) cardImg.src = d.src;
      cardImg.alt = d.label || '';
      cardLabel.textContent = d.label || '';
      card.href = d.url || '#';
    };
    var B = buildMenu(ddBuckets, 'rhx-mm--buckets', tonnages, bAside, {
      onSelect: function (i, list) {
        var t = tonnages[i];
        shopAll.href = t.url || '#';
        shopAll.querySelector('.rhx-mm-cta-text').textContent = 'Shop all ' + t.name;
        var links = all(list, '.rhx-mm-links a');
        var dataOf = function (a) {
          var type = txt(a), h = imageFor(t.name, type);
          return h ? { src: h.src, label: h.label || type, url: h.url || a.getAttribute('href') } : null;
        };
        /* Starts on the first bucket type with an image, else the tonnage's own image */
        var firstA = links.filter(function (a) { return !!dataOf(a); })[0];
        var def = firstA ? dataOf(firstA) : t.own;
        var mark = function (a) { links.forEach(function (x) { x.classList.toggle('is-current', x === a); }); };
        showCard(def);
        links.forEach(function (a) {
          a.addEventListener('mouseenter', function () { var d = dataOf(a); mark(d ? a : null); showCard(d || def); });
        });
      }
    });

    var H = buildMenu(ddHitches, 'rhx-mm--hitches', hitchRows, contentAside(cHitches));
    var W = buildMenu(ddWear, 'rhx-mm--wear', wearRows, contentAside(cWear), { noList: true });
    var A = buildMenu(ddAbout, 'rhx-mm--about', aboutRows, contentAside(cAbout), { emptyText: function (r) { return 'Go to ' + r.name; } });

    /* ---------- Size + position: centred under the header ---------- */
    var place = function (dd, p) {
      var vw = document.documentElement.clientWidth;
      var bar = menu.getBoundingClientRect(), r = dd.getBoundingClientRect();
      var side = Math.max(24, Math.round(vw * 0.04));
      var Wd = Math.min(1624, vw - side * 2);
      var L = Math.round((vw - Wd) / 2);
      var Ht = Math.max(420, Math.min(640, Math.round(window.innerHeight - Math.max(bar.bottom, 0) - 48)));
      /* The logo is drawn over the panel's top-left corner: start the content below it */
      var base = Math.max(24, Math.min(36, Math.round(vw * 0.024)));
      var logo = all(document, '.header-logo').map(function (x) { return x.getBoundingClientRect(); })
        .filter(function (b) { return b.width && b.bottom > bar.bottom && b.right > L && b.left < L + Wd * 0.3; })[0];
      var padTop = logo ? Math.max(base, Math.round(logo.bottom - bar.bottom) + 14) : base;
      p.style.setProperty('top', Math.round(bar.bottom - r.top) + 'px', 'important');
      p.style.setProperty('left', Math.round(L - r.left) + 'px', 'important');
      p.style.setProperty('width', Wd + 'px', 'important');
      p.style.setProperty('height', Ht + 'px', 'important');
      p.style.setProperty('padding-top', padTop + 'px', 'important');
      requestAnimationFrame(function () { all(p, '.rhx-mm-scroll').forEach(function (sc) { if (sc.rhxUpdate) sc.rhxUpdate(); }); });
    };
    var built = [[ddMachine, M], [ddBuckets, B], [ddHitches, H], [ddWear, W], [ddAbout, A]];
    built.forEach(function (x) {
      var dd = x[0], b = x[1];
      b.reset();
      new MutationObserver(function () {
        if (dd.classList.contains('rhx-open')) place(dd, b.p);
        else b.reset();                                   // closed: back to the first row
      }).observe(dd, { attributes: true, attributeFilter: ['class'] });
    });
    window.addEventListener('resize', function () {
      built.forEach(function (x) { if (x[0].classList.contains('rhx-open')) place(x[0], x[1].p); });
    });

    /* Preload the hover images the first time the Buckets menu opens */
    var preloaded = false;
    new MutationObserver(function () {
      if (preloaded || !ddBuckets.classList.contains('rhx-open')) return;
      preloaded = true;
      (data.hoverImages || []).forEach(function (h) { if (h.src) { var im = new Image(); im.src = h.src; } });
    }).observe(ddBuckets, { attributes: true, attributeFilter: ['class'] });

    return true;
  }

  function init() {
    /* The large menu replaces the old dropdowns; if it is turned off (or cannot
       be built) the previous menu below carries on as before. */
    var mega = false;
    try { mega = buildMega(); } catch (e) { if (window.console) console.error('Rhinox desktop menu:', e); }
    if (mega) return;
    build();
    applyFirstDefaults();
    Array.prototype.forEach.call(document.querySelectorAll('.rhinox-menu .dropdown-content.row-full'), function (p) {
      if (p.querySelector('.rhx-aside')) bindHover(p);
    });
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
